<template>
    <div class="vr-custom-page">
        <!--    建筑信息    -->
        <div class="construction-view-content">
            <!--  信息容器  -->
            <div class="info-view">
                <!--     标题     -->
                <div class="info-title">
                    <span>{{ "上海市" }}</span>
                    <span>{{ " -" }}</span>
                    <span>{{ "松江区明中路" }}</span>
                </div>
                <div class="info-option">
                    <div class="info-option-item" v-for="item in arrInfoOptionList" :key="item.key">
            <span class="option-value" :class="{ 'num-value': item.util }">
              <span>{{ item.value }}</span>
              <span class="util" v-if="item.util">{{ item.util }}</span>
            </span>
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <!--         家庭成员        -->
                <div class="info-family">
                    <div class="title">家庭成员</div>
                    <div class="num">{{ 3 }}人</div>
                    <div>(含儿童)</div>
                </div>
            </div>
        </div>
        <!--     平面图纸   -->
        <div class="plane-drawings-content default-out-content">
            <div class="view-default-title">平面图纸</div>
            <div class="drawings-view">
                <div class="plan-img" v-for="item in arrPlanImg" :key="item.key">
                    <img v-show="item.key === sActivePlan" :src="item.imgUrl" alt=""/>
                </div>
                <div class="plan-name">
                    <div
                        class="name-item"
                        v-for="item in arrPlanImg"
                        :key="item.key"
                        :class="{ 'name-item-active': item.key === sActivePlan }"
                        @click="handlePlanName(item.key)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <!--    3D图纸    -->
        <div class="three-D-drawings-content default-out-content">
            <div class="view-default-title">3D图纸</div>
            <div class="three-view">
                <img class="three-image" :src="require('@/assets/images/vr/common/0010-test.jpg')" alt=""/>
                <div class="look-detail">
                    <img class="three-icon" :src="require('@/assets/images/vr/common/three-d-icon.png')" alt=""/>
                    <div class="three-btn"><a
                        href="https://bim.zhuxingyun.com/viewer?id=c3688b338ec848d3a4aa7d3e22a7e960">点击查看</a></div>
                </div>
            </div>
        </div>
        <!--    方案定制依据    -->
        <div class="custom-basis-content default-out-content">
            <div class="view-default-title">方案定制依据</div>
            <div class="basis-view">
                <!--        房屋特性        -->
                <div class="basis-view-item">
                    <customTitle title="房屋特性"/>
                    <div class="characteristics-content">
                        <!--            循环项            -->
                        <div class="characteristics-item" v-for="item in arrCharacteristics" :key="item.name">
                            <span class="title">{{ item.name }}</span>
                            <span>{{ item.value }}</span>
                        </div>
                    </div>
                </div>

                <!--    线        -->
                <div class="liner"></div>

                <!--        用户个性化需求        -->
                <div class="basis-view-item">
                    <customTitle title="用户个性化需求"/>
                    <customPerson v-for="item in objUserCustomListData" :sourceList="item.children" :key="item.sub"
                                  :title="item.title" class="personalized-tag"/>
                </div>
            </div>
        </div>
        <!--   VIP系统定制方案     -->
        <div class="system-custom-content default-out-content">
            <div class="view-default-title">VIP系统定制方案</div>
            <div class="system-content">
                <!--        设计参数        -->
                <div class="system-view-item">
                    <customTitle title="设计参数"/>
                    <customCharacter :sourceList="objDesignParamsData[1]" title="冷暖系统" class="parameters-tag"/>
                    <customCharacter :sourceList="objDesignParamsData[3]" title="新风系统" class="parameters-tag"/>
                    <customCharacter :sourceList="objDesignParamsData[4]" title="水系统" class="parameters-tag"/>
                </div>
                <!--    线        -->
                <div class="liner"></div>
                <!--        系统配置        -->
                <div class="system-view-item">
                    <customTitle title="系统配置"/>
                    <div class="option-content">
                        <div class="option-item" v-for="item in arrProductInfo" :key="item.img"
                             @click="goToDetail(item)">
                            <div class="img-pro"><img class="option-image" v-lazy="item.img" alt=""/></div>
                            <div class="option-text">{{ item.name }}<br/>{{ item.type }}</div>
                        </div>
                    </div>
                </div>

                <!--        系统功能        -->
                <div class="system-view-item">
                    <customTitle title="系统功能"/>
                    <div class="function-content">
                        <customSystem v-for="item in arrSystemFunctionList" :info="item" :open="item.open"
                                      :key="item.name" class="function-tag"/>
                    </div>
                </div>


            </div>
        </div>

        <!--     底部切换栏    -->
        <div class="tab-bar-content">
            <div class="tab-item" v-for="item in arrTabBarList" :key="item.key" @click="handleSwitchTab(item)">
                <a class="hrefA" :href="item.backUrl">
                    <img v-if="item.key != sActiveTab" :src="item.icon" alt=""/>
                    <img v-else :src="item.activeIcon" alt=""/>
                    <div class="tab-text">{{ item.name }}</div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import customTitle from "../../../detail/custom/components/custom-title";
import customPerson from "../../../detail/custom/components/custom-person";
import customCharacter from "../../../detail/custom/components/custom-character";
import customSystem from "../../../detail/custom/components/custom-system";
import {mapState} from "vuex";

export default {
    name: "index",
    components: {
        customTitle,
        customPerson,
        customCharacter,
        customSystem,
    },
    data() {
        return {
            // 平面图数据
            arrPlanImg: [
                {name: "负一层", imgUrl: require("@/assets/images/vr/shanghai/01/B1-.png"), key: "B1"},
                {name: "一层", imgUrl: require("@/assets/images/vr/shanghai/01/F1-.png"), key: "F1"},
                {name: "二层", imgUrl: require("@/assets/images/vr/shanghai/01/F2-.png"), key: "F2"},
                {name: "三层", imgUrl: require("@/assets/images/vr/shanghai/01/F3-.png"), key: "F3"},
            ],
            // 配置参数数组
            arrInfoOptionList: [
                {
                    name: "建筑面积",
                    key: "area",
                    util: "m²",
                    value: "260",
                },
                {
                    name: "房型",
                    key: "roomType",
                    value: "5室2厅",
                },
                {
                    name: "房屋种类",
                    key: "floorType",
                    value: "别墅",
                },
                {
                    name: "项目造价",
                    key: "price",
                    util: "万",
                    value: "32",
                },
            ],

            // 房屋特性数组
            arrCharacteristics: [
                {
                    name: "房屋朝向",
                    value: "南北向",
                },
                {
                    name: "层高",
                    value: "3m",
                },
                {
                    name: "房屋保温",
                    value: "外墙保温",
                },
                {
                    name: "用水点",
                    value: "4卫1厨",
                },
                {
                    name: "冬季平均最低气温",
                    value: "3°c",
                },
                {
                    name: "冬季进水温度",
                    value: "4°c",
                },
            ],
            // 底部切换栏渲染数据
            arrTabBarList: [
                {
                    icon: require("@/assets/images/vr/common/programme.png"),
                    activeIcon: require("@/assets/images/vr/common/programme-active.png"),
                    name: "定制方案",
                    key: "custom",
                },
                {
                    icon: require("@/assets/images/vr/common/install.png"),
                    activeIcon: require("@/assets/images/vr/common/install-active.png"),
                    name: "设备定位",
                    key: "customBefore",
                },
                {
                    icon: require("@/assets/images/vr/common/renovation.png"),
                    activeIcon: require("@/assets/images/vr/common/renovation-active.png"),
                    name: "安装施工",
                    key: "customization",
                },
                {
                    icon: require("@/assets/images/vr/common/home.png"),
                    activeIcon: require("@/assets/images/vr/common/home-active.png"),
                    name: "成品房",
                    key: "afterCustom",
                },
            ],
            // 激活的tab
            sActiveTab: "custom",
            //激活的平面图
            sActivePlan: "B1",
        };
    },
    computed: {
        ...mapState({
            // 用户个性化需求数据
            objUserCustomListData: (state) => state.projectDetailCustom.objUserCustomListData,
            // 设计参数数据
            objDesignParamsData: (state) => state.projectDetailCustom.objDesignParamsData[0],
            // 产品数据
            arrProductInfo: (state) => state.projectDetailCustom.arrProductInfo,
            // 系统功能
            arrSystemFunctionList: (state) => state.projectDetailCustom.arrSystemFunctionList,
        }),
    },
    created() {
        //   获取vr页面跳转过来的参数
        let startscene = this.$route.query.startscene
        this.arrTabBarList.forEach(item => {
            if (item.key === 'customBefore') {
                item.backUrl = `https://expos.3g2.cn/expo/aosmith/index.html?startscene=A${startscene} `
            } else if (item.key === 'customization') {
                item.backUrl = `https://expos.3g2.cn/expo/aosmith/index.html?startscene=B${startscene} `
            }
        })
        this.$store.commit("loadSwitch", true);
        setTimeout(() => {
            this.$store.commit("loadSwitch", false);

        }, 1500)
    },
    mounted() {
    },
    methods: {
        /**
         * 切换tab
         * @param item
         */
        handleSwitchTab(item) {
            this.sActiveTab = item.key;
        },
        // 切换平面图楼层
        handlePlanName(key) {
            this.sActivePlan = key;
        },
        goToDetail(item) {
            this.$router.push(
                item.id === 1045
                    ? {path: "/shopp/details", query: {id: item.id}}
                    : {path: "/project/detail/custom/image-view", query: {id: item.id}}
            );
        },
    },
};
</script>

<style scoped lang="scss">
.vr-custom-page {
    min-height: 100vh;
    padding: 28px 24px 40px;
    font-size: $baseSize;
    padding-bottom: 170px;

    .view-default-title {
        padding: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 36px;
        font-weight: 500;
        background: $greenGradient;
    }

    .construction-view-content {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: $boxShadow;
        margin-bottom: 24px;

        .info-view {
            background: $greenGradient;
            color: #ffffff;
            padding: 32px 24px;

            .info-title {
                font-size: 36px;
                font-weight: 700;
                margin-bottom: 24px;
            }

            .info-option {
                display: flex;
                justify-content: space-around;
                align-items: stretch;
                margin-bottom: 48px;

                .info-option-item {
                    flex: 0 0 25%;
                    border-right: 1px solid rgba(#ffffff, 0.3);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-end;
                    color: rgba(#ffffff, 0.6);

                    &:last-child {
                        border: none;
                    }

                    .option-value {
                        font-size: 34px;
                        color: #ffffff;
                        font-weight: 600;
                        margin-bottom: 20px;

                        .util {
                            font-size: $baseSize;
                        }
                    }

                    .num-value {
                        font-size: 54px;
                        line-height: 54px;
                        margin: 10px;
                    }
                }
            }

            .info-family {
                display: flex;
                align-items: center;
                color: rgba(#ffffff, 0.6);

                div {
                    margin-right: 20px;
                }

                .title {
                    line-height: 46px;
                    width: 140px;
                    border-radius: 46px;
                    text-align: center;
                    border: 1px solid rgba(#ffffff, 0.3);
                }
            }
        }
    }

    .default-out-content {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: $boxShadow;
        margin-bottom: 24px;

        .drawings-view {
            .plan-name {
                display: flex;
                justify-content: space-around;
                padding: 0 40px 30px 40px;

                .name-item {
                    flex: 1;
                    text-align: center;
                    font-size: 28px;
                    font-weight: 400;
                    color: #a2a2a2;
                    line-height: 40px;
                }

                .name-item-active {
                    color: #21914b;
                }
            }
        }
    }

    .three-D-drawings-content {
        .three-image {
            object-fit: cover;
        }

        .three-view {
            position: relative;
            overflow: hidden;
            width: 100%;
            height: 294px;
            display: flex;
            justify-content: center;
            align-items: center;

            .look-detail {
                position: absolute;

                .three-icon {
                    width: 100px;
                    height: 100px;
                    display: block;
                    margin: 0 auto 12px;
                }

                .three-btn {
                    padding: 8px 20px;
                    border-radius: 50px;
                    background: rgba(#000000, 0.6);
                    color: #ffffff;
                    font-size: $smallSize;

                    a {
                        color: #ffffff;
                        text-decoration: none;
                    }
                }
            }
        }
    }

    .custom-basis-content {
        .liner {
            height: 1px;
            margin: 0 24px;
            background: rgba($defaultGary, 0.3);
        }

        .basis-view-item {
            padding-top: 30px;

            .characteristics-content {
                padding: 20px 20px;
                display: flex;
                flex-wrap: wrap;

                .characteristics-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 24px;

                    &:nth-child(odd) {
                        flex: 0 0 63%;
                    }

                    .title {
                        color: $defaultGreen;
                        padding-right: 12px;
                        white-space: nowrap;
                    }
                }
            }

            .personalized-tag {
                padding: 0 24px;
                margin-top: 28px;
            }
        }
    }

    .system-custom-content {
        .system-view-item {
            padding-top: 30px;

            .parameters-tag {
                padding: 24px;
            }

            .function-content {
                padding-top: 40px;
                font-size: 32px;

                .function-tag {
                    padding: 0 24px 26px;
                }
            }

            .option-content {
                padding: 32px 24px;
                display: flex;
                // justify-content: space-between;
                flex-wrap: wrap;
                font-size: $smallSize;
                color: #ffffff;

                .option-item {
                    // width: 198px;
                    width: 210px;
                    height: 310px;
                    // height: 336px;
                    // height: 300px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    border-radius: 10px;
                    margin-bottom: 32px;
                    overflow: hidden;
                    box-shadow: $boxShadow;
                    margin-right: 10px;

                    &:nth-child(3n) {
                        margin-right: 0;
                    }

                    .img-pro {
                        width: 202px;
                        height: 192px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .option-image {
                        overflow: hidden;
                        // width: 100%;
                        height: auto;
                        // flex: 0 0 220px;
                    }

                    .option-text {
                        flex: 1;
                        background: $defaultGreen;
                        display: flex;
                        align-items: center;
                        padding: 0 15px;
                        width: 100%;
                        font-size: 24px;
                    }

                    &:nth-child(5) {
                        .option-text {
                            padding: 0 10px 0 5px;
                        }
                    }
                }
            }
        }
    }
}

.tab-bar-content {
    width: 100%;
    height: 178px;
    background: linear-gradient(180deg, #4ca365 0%, #388e4c 100%);
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-around;
    padding-top: 18px;

    .tab-item {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-content: flex-start;

        .hrefA {
            display: block;
            text-align: center;
        }

        img {
            width: 48px;
            height: 48px;
        }

        .tab-text {
            text-align: center;
            width: 100%;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
            line-height: 32px;
            margin-top: 8px;
        }
    }
}
</style>
